import React from 'react';
import {TextField} from "@mui/material";

const MaterialOptimizationTextFieldObjectWithEntityList = ({label, setId, field, entityList, disabled}) => {
    return (
        <div>
            <TextField
                autoComplete={"off"}
                size={"small"}
                disabled={disabled}
                key={field}
                sx={{
                    width: '100%',
                    minWidth: {xs: '300px', sm: '360px', md: '400px'},
                    gap: '1.5rem',
                }}
                margin="normal"
                select
                label={label}
                name={field}
                onChange={(e) =>
                    setId(e.target.value)
                }
                SelectProps={{
                    native: true,
                }}
            >
                {entityList.map((entity) => (
                    <option
                        key={entity.id}
                        value={entity.id}>
                        {entity.name}
                    </option>
                ))}
            </TextField>
        </div>
    );
};

export default MaterialOptimizationTextFieldObjectWithEntityList;